<template>
  <div id="support-faq-container">
    <!-- <div id="product-faq-wrapper" class="d-flex justify-space-between mx-auto mt-3 mt-sm-9">
      <router-link
        :to="product.path"
        class="faq-product-type mx-2 my-1 pa-2"
        v-for="(product, index) in products"
        :key="index"
      >
        <div class="sprite mx-auto" :class="product.spriteClass"></div>
        <div class="faq-product-title light-grey font-size-14 text-center mt-3">{{ product.title }}</div>
      </router-link>
    </div> -->
    <!-- <v-sheet max-width="670px" class="mx-auto">
      <router-view></router-view>
    </v-sheet> -->
    <!-- <div id="faq-contact-us-wrapper" class="text-center">
      <div class="font-italic font-size-14">Can't find what your are looking for ?</div>
      <v-btn
        class="mt-2"
        color="#e2211c"
        outlined
        tile
        width="350px"
        to="/support/contact_us"
      >send us your question</v-btn>
    </div> -->


    <div>

          <div>
              <h3>Getting Started</h3>
               <br>
              <div class="data01" v-if="showFaqData01">
                <p>1. Make sure your device's Bluetooth is turned on, and you've downloaded the 1byone health app.</p>
                 <li>To download the app, go to the app store on your device (App Store for iOS or Play Store for Android) and search for “1byone health”, or follow these links:</li>
                <a href="https://www.1byonehealth.com/download/pages/health.html"  target="_blank">Download the Android App</a><br>
                <a href="https://www.1byonehealth.com/download/pages/health.html"  target="_blank">Download the iOS App</a><br><br>

                <p>2. Create an account and fill out the information the app needs to calculate your body composition.</p>
                    <p> 3. With the app still open, Install the batteries, and place it on a hard, flat surface,follow the guided steps to connect to the scale.If you miss this, you can also add the scale manually by tapping "Add" in the side menu,and then selecting your model of Bluetooth scale.</p>
                    <p>4. Now that you've added your scale, step on to take your first weigh-in. Make sure your bare feet are making good contact with all four conductors.</p>
                    <p>Next time you want to weigh in, just open the 1byone health app, step on, and weigh yourself. As long as the app is open and your device is in range, your results will transfer automatically. The scale's screen will display your weight, and you will view your full body composition measurements in the app.</p>
                    <p>AND, REMEMBER ...</p>
                    
                    <li>Always place your scale on a hard, level surface—placing it on carpet or across multiple floor tiles will give you inaccurate results.</li>
                    <li> Step on the scale with bare feet,Wearing socks or shoes during weighing will result in incorrect body composition measurements. </li>
                    <li> Body composition will only be displayed if a user has properly set up a profile in the app, because these readings require specific variables such as height, sex, and activity level.</li>

                      <div></div>
                      <div></div>
                      <div></div>
              </div>
            <br><br>
          </div>


            <div>
              <h3>FAQs</h3>
              <br>
                  <div 
                    v-for="faq in faqData1"
                    :key="faq.title"
                    :title="faq.title" 
                    >
                    <h4>{{ faq.title }}</h4>
                    <br> 
                    <p>{{ faq.centent }}</p> 
                    <br> 
                </div>

            </div>

            <div>
                          <div>
                            <h3>TECH SPECS</h3>
                             <img src="../../assets/specifications.png"  alt="">
                             <br>
                             <br>
                          </div>

                               <div>
                              <h3>TROUBLESHOOTING</h3>
                             <img src="../../assets/troubleshoot.png"  alt="">
                             <br>
                             <br>
                          </div>

                               <div>
                                 <h3>TYPICAL RESULTS</h3>
                             <div>
                                <p>{{ f01Data1.TYPICALRESULTS_MOBILE1}}<br>{{ f01Data1.TYPICALRESULTS_MOBILE2}}<br>{{ f01Data1.TYPICALRESULTS_MOBILE3}}</p>
                             </div>
                             <br>
                          </div>

                               <div >
                                 <h3>WARRANTY TERMS</h3>
                             <div>
                                <p>{{ f01Data1.WARRANTYTERMS1}}<br>{{ f01Data1.WARRANTYTERMS2}}<br>{{ f01Data1.WARRANTYTERMS3}}<br>{{ f01Data1.WARRANTYTERMS4}}<br>{{ f01Data1.WARRANTYTERMS5}}<br>{{ f01Data1.WARRANTYTERMS56}}{{ f01Data1.WARRANTYTERMS7}}</p>
                             </div>
                             <br>
                          </div>

                               <div>
                                  <h3>WARNINGS</h3>
                             <div>
                               <p>{{ f01Data1.WARNINGS1}}<br>{{ f01Data1.WARNINGS2}}<br>{{ f01Data1.WARNINGS3}}<br>{{ f01Data1.WARNINGS4}}<br>{{ f01Data1.WARNINGS5}}<br>{{ f01Data1.WARNINGS6}}<br>{{ f01Data1.WARNINGS7}}<br>{{ f01Data1.WARNINGS8}}<br>{{ f01Data1.WARNINGS9}}<br>{{ f01Data1.WARNINGS10}}<br>{{ f01Data1.WARNINGS11}}<br>{{ f01Data1.WARNINGS12}}<br>{{ f01Data1.WARNINGS13}}<br>{{ f01Data1.WARNINGS14}}<br>{{ f01Data1.WARNINGS15}}<br>{{ f01Data1.WARNINGS16}}<br>{{ f01Data1.WARNINGS17}}</p>
                             </div>
                             <br>
                          </div>
            </div>

    </div>

  </div>
</template>


<script>
import { faq01PcData } from "../../mixins/faqData"
import { f01Data } from "../../mixins/faqData"
export default {
  metaInfo: {
    title: "FAQ | 1byone health",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "1byone health always would like to receive any review and feedback from customer's perspective, and turn it into improving our technology, product and service."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "1byone, 1byone health, product support,free support,product questions,product faq,manuals"
      }
    ]
  },
  mounted () {
      
      var spId=sessionStorage.getItem("pid");

      if(spId=="A07"||spId=="A06"||spId=="A10"||spId=="A05"||spId=="A08"){
      this.faqData1 = faq01PcData();
      this.f01Data1 = f01Data();
      this.showFaqData01=true;
      }
    },
  data: () => ({
  showFaqData01 :false,
    // faq内容
  faqData1:[],
  f01Data1:null,
    products: [
      {
        title: "Scale",
        path: "scale",
        spriteClass: "sprite-faq_scale"
      },
      {
        title: "Blood Pressure Monitor",
        path: "bp",
        spriteClass: "sprite-faq_bp"
      },
      {
        title: "Oximeter",
        path: "oximeter",
        spriteClass: "sprite-faq_oximeter"
      },
      {
        title: "TENS",
        path: "tense",
        spriteClass: "sprite-faq_tense"
      }
    ]
  })
};
</script>


<style scoped>
.sprite {
  background-image: url(https://media.1byonehealth.com/image/support/productFaqSprite.png);
  background-repeat: no-repeat;
  display: block;
}

.sprite-faq_bp {
  width: 147px;
  height: 119px;
  background-position: -50px -50px;
}

.sprite-faq_oximeter {
  width: 92px;
  height: 119px;
  background-position: -297px -50px;
}

.sprite-faq_scale {
  width: 117px;
  height: 119px;
  background-position: -489px -50px;
}

.sprite-faq_tense {
  width: 80px;
  height: 119px;
  background-position: -736px -50px;
}

#product-faq-wrapper {
  max-width: 762px;
  overflow-x: auto;
}

#product-faq-wrapper::-webkit-scrollbar {
  display: none;
}

.faq-product-type {
  flex-shrink: 0;
}

#faq-contact-us-wrapper {
  margin-top: 65px;
  margin-bottom: 65px;
  color: #666666;
}

.router-link-exact-active {
  webkit-box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
}
</style>